module.exports = __webpack_public_path__ + "img/V-R-2-unload-connect.1a8bfc18.png";